'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FacebookIcon = require('./FacebookIcon');

var _FacebookIcon2 = _interopRequireDefault(_FacebookIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FacebookIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FacebookIcon/index.js
// module id = 264
// module chunks = 11